<span [class.text-placeholder]="!user" [ngClass]="{'fix-width-user-name': fixWidth}">{{ name }}</span>
